/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { MeasuringUnitsClient } from '../../data/web-api-client';
import AxiosClient from '../../data/AxiosClient';
import { Module } from 'vuex';

const measuringUnitsModule: Module<any, any> = {
  namespaced: true,
  state: {
    loading: true,
    initialised: false,
    data: {},
  },
  getters: {
    data: (state: any) => state.data,
    loading: (state: any) => state.loading,
  },
  mutations: {
    setData(state, data) {
      state.initialised = true;
      state.data = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
  },
  actions: {
    async fetch({ commit, dispatch, state }) {
      if (!state.initialised) {
        await dispatch('load');
      }
    },
    async load({ commit, dispatch }) {
      commit('setLoading', true);
      try {
        const client = new MeasuringUnitsClient(undefined, AxiosClient);
        commit("setData", (await client.getMeasuringUnits()).map(mu => mu.name));
      } catch (err) {
        setTimeout(() => {
          dispatch('load');
        }, 3000);
      } finally {
        commit('setLoading', false);
      }
    },
  },
};

export default measuringUnitsModule;
